import Axios from 'axios';
import { useEffect, useState } from 'react';

const useFetch = (url: string) => {
  const [state, setState] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data } = await Axios.get(url);
        setState(data);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };
    fetchData();
  }, [url]);
  return { state, error, loading };
};

export default useFetch;
